
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'oxd-grid',

  props: {
    cols: {
      type: Number,
    },
  },

  computed: {
    className(): string {
      return `oxd-grid-${this.cols}`;
    },
  },
});
